import { SVGProps } from "react"

const ArrowDownIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17 9.85547L12.781 13.4718C12.3316 13.857 11.6684 13.857 11.2191 13.4718L7 9.85547"
        stroke="#0E2846"
        strokeLinecap="round"
      />
    </svg>
  )
}
export default ArrowDownIcon
